export default __webpack_public_path__ + "static/media/saqib.3bf2762d.jpg";